import type { LiveStateGetResponse, LiveEventStateGetResponse } from 'types/live-state';
import { GetHvJson, GetJson, HvHostMap } from './helpers';
import blAuth from './bl-auth/bl-auth';

export const GetSessionLiveState = async (sessionUuid: string) => {
	return await GetHvJson<LiveStateGetResponse>({
		path: `/e3-current-stream-state/${sessionUuid}`,
		service: HvHostMap.eventData
	});
};

export const GetEventLiveStates = async (eventUuid: string) => {
	return await GetHvJson<LiveEventStateGetResponse>({
		path: `/e3-current-event-stream-state/${eventUuid}`,
		service: HvHostMap.eventData
	});
};

export interface ChannelLiveState {
	event_uuid: string;
	session_uuid: string;
}
export const GetChannelLiveStates = async (channel: number) => {
	return GetJson<ChannelLiveState[]>({
		path: `/v3/admin/channel/${channel}/events/currently-live-streaming`,
		token: '' // no longer required in auth v2
	});
};